export default "__VITE_ASSET__BMpLobA1__$_?url__"